import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

/**
 * 56px 헤더.
 *
 * 상단 safe-area(status bar) 는 Flutter 가 webview 컨테이너에 native inset 으로 직접
 * 확보하므로 헤더는 추가 padding-top 없이 56px content 만 차지한다.
 * (webview 에서 --safe-top 을 또 주면 이중 적용돼 헤더가 그만큼 더 내려감)
 */
export const HeaderWrapper = styled.header`
  flex: 0 0 auto;
  width: 100%;
  background-color: ${COLORS.bgWhite};
  z-index: 10;
`

export const HeaderContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  padding: 4px;
`

export const BackButton = styled.button`
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 0;
  border-radius: 9999px;
  background: transparent;
  color: ${COLORS.textPrimary};
  cursor: pointer;
`

export const Title = styled.h1`
  margin: 0;
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.18px;
  color: ${COLORS.textPrimary};
  text-align: center;
`
